import React from "react";
import TermsContent from "./TermsContent";
import "./TermsTab.css";

const TermsTab = () => {
  return (
    <div className="terms-tab">
      <h2>Terms & Conditions</h2>
      <TermsContent />
    </div>
  );
};

export default TermsTab;
